<textarea [(ngModel)]="value" (change)="onChange()"  class="text-area" placeholder="Paste your code snippet here..."></textarea>
